// extracted by mini-css-extract-plugin
export default {"container":"text-aria_container__nkqh9","label":"text-aria_label__bR4sO","textField":"text-aria_textField__5gQX2"};